import type { Theme } from "@mui/material";

export default (theme: Theme) => {
  const responsiveField = {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
    },
  };

  return {
    section: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: "1rem",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        gap: "0.5rem",
        margin: "0.5rem 0",
        padding: 0,
      },
    },

    avatar: {
      position: "relative",
      [theme.breakpoints.down("md")]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginBottom: "1rem",
      },
      photo: {
        position: "relative",
        width: "6rem",
        height: "6rem",
        cursor: "pointer",
        img: {
          width: "100%",
          height: "100%",
        },
      },
      input: {
        position: "absolute",
        bottom: 0,
        left: 0,
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        width: 1,
        height: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
      },
    },

    salutationAndName: {
      flex: 1,
      gap: "1rem",
      flexDirection: "row",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        gap: 0,
      },
    },
    salutation: {
      minWidth: "6rem",
      ...responsiveField,
    },
    firstName: {
      maxWidth: "10rem",
      ...responsiveField,
    },
    lastName: {
      ...responsiveField,
    },

    twoFactorAndPassword: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      height: "3.5rem",
      [theme.breakpoints.down("md")]: {
        gap: "1rem",
        height: "auto",
        margin: "1rem 0 0.5rem 0",
      },
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
      },
    },
    changePassword: {
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
      },
    },
    twoFactorAuth: {
      alignItems: "center",
      "& .MuiFormControlLabel-root": {
        marginRight: "1ex",
      },
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
        "& svg": {
          display: "none",
        },
      },
    },
  };
};
